import { createApp, createSSRApp, defineAsyncComponent } from 'vue';
import router from './router';
import store from './store';
import { getInitialFilters } from '@/helpers';
import { WindowFilterInitListing } from './types';

console.log('v12');
// set data from page js
// On yarn serve, some things fire twice due to multiple mounts of the same app (eg: VehicleApp on savedvehiclesRoot and vehiclesRoot) but this shouldn't happen on build as saved isn't on the same page as vehicles. To fix you can comment out saved or vehicles etc in this file.

const filterInit: WindowFilterInitListing = (window as any).uvFilterInit;
const allStockCategoryIds = filterInit?.StockCategoryIds || [];
const stockCategoryIds = filterInit?.StockCategoryIds?.length ? filterInit?.StockCategoryIds : [(window as any).uvSearchConditionDefault];
const showLocation = filterInit.FilterLocations?.length > 1;
const hasPreYearValue = filterInit.HasPreYearValue;


let savedVehicles: Array<string> = [];
let viewedVehicles: Array<string> = [];
for (let i = 0; i != allStockCategoryIds.length; ++i){
	const rawSavedVehicles = localStorage.getItem('uvSaved-' + allStockCategoryIds[i]) || '[]';
	const rawViewedVehicles = localStorage.getItem('uvRecentlyViewed-' + allStockCategoryIds[i]) || '[]';
	savedVehicles = [...savedVehicles, ...(JSON.parse(rawSavedVehicles))];
	viewedVehicles = [...viewedVehicles, ...(JSON.parse(rawViewedVehicles))];
}
console.log(savedVehicles)
console.log(allStockCategoryIds)
console.log(filterInit)

console.log("uvFilterInit available?", (window as any).uvFilterInit);
console.log("Known category IDs on page load:", allStockCategoryIds);
console.log("Saved vehicles on page load:", savedVehicles);

store.commit('setHasPreYearValue', hasPreYearValue);
store.commit('setShowLocation', showLocation);
store.commit('setLocations', filterInit?.FilterLocations || []);
store.commit('setCtas', (window as any).uvCtas);
store.commit('setBrandId', (window as any).uvBrandId);
store.commit('setStockCategoryIds', stockCategoryIds);
store.commit('setSavedVehicles', savedVehicles);
store.commit('setViewedVehicles', viewedVehicles);

const adTilesData = filterInit?.AdvertisingTiles;

console.log('CRITICAL LOG: What is in filterInit.AdvertisingTiles?', adTilesData);

if (adTilesData) {
	console.log('SUCCESS: Committing ad tiles to store:', adTilesData);
    store.commit('setAdTiles', adTilesData);
}

store.commit('setVehicles', filterInit?.InitialVehicles || []);
store.commit('setTotalVehicles', (window as any).uvTotalVehicles || -1);

store.commit('filters/setFilters', getInitialFilters());

if (hasPreYearValue){
	store.commit('filters/setFilters', {
		...store.state.filters, 
		yearMin: filterInit.YearMin - 1
	});
}

const topBarRoot = document.getElementById('uv-topbar-root');
const filtersRoot = document.getElementById('uv-filters-root');
const vehiclesRoot = document.getElementById('uv-vehicles-static');
const savedVehiclesRoot = document.getElementById('uv-savedvehicles-root');
const paginationRoot = document.getElementById("pagination-root");
// const routerRoot = document.getElementById("uv-router-root");
const searchRoot = document.getElementById("search-cars-root");
const searchFullRoot = document.getElementById("search-full-root");
const detailEnquireRoot = document.querySelectorAll(".uv-enquire-modal-button");
const detailSidebarRoot = document.getElementById("uv-sidebar-root");
const modalRoot = document.getElementById("uv-modal-root");
const detailCertifiedRoot = document.querySelectorAll(".uv-tile-toyotacertified");
const detailPageBookTestDriveRoot = document.querySelectorAll(".uv-book-test-drive-root");
const bookmarkBtnRootDesktop = document.getElementById('uv-details-bookmark-desktop');
const bookmarkBtnRootMobile = document.getElementById('uv-details-bookmark-mobile');
const VehicleQuickLookCta = defineAsyncComponent(() => import('@/VehicleApp/VehicleQuickLookCta.vue'));

if (detailPageBookTestDriveRoot.length){
	const BookApp = defineAsyncComponent(() => import(/* webpackChunkName: "booktestdrive" */'@/DetailApp/DetailSidebarApp.vue'));
	for (let i = 0; i != detailPageBookTestDriveRoot.length; ++i){
		const dataset = (detailPageBookTestDriveRoot[i] as HTMLElement).dataset;
		createApp(BookApp, { ...dataset }).use(store).mount(detailPageBookTestDriveRoot[i]);
	}
}

function setupBookmarkButton(buttonElement: HTMLElement) {
    if (!buttonElement) return;

    const stockId = buttonElement.dataset.stockId || '';
    const categoryId = buttonElement.dataset.stockCategoryId || '';

    if (!stockId || !categoryId) return;

    const storageKey = `uvSaved-${categoryId}`;

    buttonElement.innerHTML = `<img src="/img/redesign/icons/white-bookmark-new.svg" alt="Save" class="save-icon" />`;
    const icon = buttonElement.querySelector('img');

	// visually saving - working correctly
    function syncVisualState() {
        if (!icon) return; 

        const savedItems = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (savedItems.includes(stockId)) {
            buttonElement.classList.add('is-saved');
            icon.src = '/img/redesign/icons/black-bookmark.svg';
            icon.alt = 'Saved';
        } else {
            buttonElement.classList.remove('is-saved');
            icon.src = '/img/redesign/icons/white-bookmark-new.svg';
            icon.alt = 'Save';
        }
    }

    buttonElement.addEventListener('click', () => {
        const savedInCategory = JSON.parse(localStorage.getItem(storageKey) || '[]');
        const isCurrentlySaved = savedInCategory.includes(stockId);

        if (isCurrentlySaved) {
            const index = savedInCategory.indexOf(stockId);
            if (index > -1) {
                savedInCategory.splice(index, 1);
            }
			
        } else {
            savedInCategory.push(stockId);
        }
        
        localStorage.setItem(storageKey, JSON.stringify(savedInCategory));

        let allSaved: string[] = [];
        for (let i = 0; i < allStockCategoryIds.length; i++) {
            const categoryKey = `uvSaved-${allStockCategoryIds[i]}`;
            const itemsInCat = JSON.parse(localStorage.getItem(categoryKey) || '[]');
            allSaved = [...allSaved, ...itemsInCat];
        }

        store.commit('setSavedVehicles', [...new Set(allSaved)]);


        syncVisualState();
    });

    syncVisualState();
}

setupBookmarkButton(bookmarkBtnRootDesktop as HTMLElement);
setupBookmarkButton(bookmarkBtnRootMobile as HTMLElement);

if (topBarRoot){
	const TopbarApp = defineAsyncComponent(() => import(/* webpackChunkName: "topbar" */'@/TopbarApp/TopbarApp.vue'));
	createApp(TopbarApp).use(store).mount(topBarRoot);
}
if (filtersRoot){
	const FilterApp = defineAsyncComponent(() => import(/* webpackChunkName: "filter" */'@/FilterApp/FilterApp.vue'));
	createApp(FilterApp).use(store).use(router).mount(filtersRoot);
}
if (vehiclesRoot){
	const VehicleApp = defineAsyncComponent(() => import(/* webpackChunkName: "vehicle" */'@/VehicleApp/VehicleApp.vue'));
	removeWhiteSpaceFromTextNodeAndNormalize(vehiclesRoot, true);
	createSSRApp(VehicleApp).use(store).mount(vehiclesRoot);
}
else if (savedVehiclesRoot){
	const VehicleApp = defineAsyncComponent(() => import(/* webpackChunkName: "vehicle" */'@/VehicleApp/VehicleApp.vue'));
	createApp(VehicleApp).use(store).mount(savedVehiclesRoot);
	let saved: Array<string> = stockCategoryIds.length ? [] : savedVehicles;
	if (stockCategoryIds.length){
		for (const i in stockCategoryIds){
			const item: string = localStorage.getItem(`uvSaved-${stockCategoryIds[i]}`) || "[]";
			const arr: Array<string> = JSON.parse(item);
			saved = [...saved, ...arr];
		}
	}
	if (saved.length){
		store.dispatch('updateVehicles', { amend: false, regos: saved})
	}
}
if (paginationRoot){
	const PaginationApp = defineAsyncComponent(() => import(/* webpackChunkName: "pagination" */'@/PaginationApp/PaginationApp.vue'));
	removeWhiteSpaceFromTextNodeAndNormalize(paginationRoot, true);
	createSSRApp(PaginationApp).use(store).mount(paginationRoot);
}
// if (routerRoot){
// 	const RouterApp = defineAsyncComponent(() => import(/* webpackChunkName: "router" */'@/RouterApp.vue'));
// 	createApp(RouterApp).use(store).use(router).mount(routerRoot);
// }
if (searchRoot){
	const SearchApp = defineAsyncComponent(() => import(/* webpackChunkName: "search" */'@/SearchApp/SearchApp.vue'));
	createApp(SearchApp).use(store).mount(searchRoot);
}
if (searchFullRoot){
	const SearchFullApp = defineAsyncComponent(() => import(/* webpackChunkName: "search-full" */'@/SearchFullApp/SearchFullApp.vue'));
	createApp(SearchFullApp).use(store).mount(searchFullRoot);
}
if (detailEnquireRoot.length){
	const DetailEnquireApp = defineAsyncComponent(() => import(/* webpackChunkName: "detail-enquire" */'@/DetailApp/DetailEnquireApp.vue'));
	for (let i = 0; i != detailEnquireRoot.length; ++i){
		removeWhiteSpaceFromTextNodeAndNormalize(detailEnquireRoot[i], true);
		createSSRApp(DetailEnquireApp).use(store).mount(detailEnquireRoot[i]);
	}
}
if (detailSidebarRoot){
	const DetailSidebarApp = defineAsyncComponent(() => import(/* webpackChunkName: "detail-sidebar" */'@/DetailApp/DetailSidebarApp.vue'));
	removeWhiteSpaceFromTextNodeAndNormalize(detailSidebarRoot, true);
	createSSRApp(DetailSidebarApp).use(store).mount(detailSidebarRoot);
}
if (modalRoot){
	const ModalApp = defineAsyncComponent(() => import(/* webpackChunkName: "modal" */'@/ModalApp/ModalApp.vue'));
	createApp(ModalApp).use(store).mount(modalRoot);
}
if (detailCertifiedRoot.length){
	const DetailCertifiedApp = defineAsyncComponent(() => import(/* webpackChunkName: "detail-certified" */'@/DetailApp/DetailCertifiedApp.vue'));
	for (let i = 0; i != detailEnquireRoot.length; ++i){
		createApp(DetailCertifiedApp).use(store).mount(detailCertifiedRoot[i]);
	}
}

function removeWhiteSpaceFromTextNodeAndNormalize(parentEl: ChildNode, normalize: boolean){
	for (const el of parentEl.childNodes){
		if (el.nodeType === Node.TEXT_NODE){
			if (el.nodeValue){
				el.nodeValue = el.nodeValue.replace(/^\s+$/g, '');
			}
		}
		else {
			removeWhiteSpaceFromTextNodeAndNormalize(el, false);
		}
	}
	normalize && parentEl.normalize();
}